var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-wrapper" }, [
    _c(
      "table",
      { staticClass: "data-table text-sm w-full font-outfit table-responsive" },
      [
        _c("thead", [
          _c(
            "tr",
            [
              _c(
                "th",
                {
                  staticClass:
                    "checkbox-header px-2 sm:px-4 py-2 sm:py-4 border-b-1 border-gray-200 text-left font-medium",
                  class: {
                    "bg-thead-primary": _vm.currentMode === "ACCEPT",
                    "bg-thead-secondary": _vm.currentMode === "REJECT",
                  },
                },
                [
                  _c("label", { staticClass: "custom-checkbox" }, [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: { checked: _vm.areAllSelected },
                      on: { change: _vm.handleSelectAll },
                    }),
                    _c("span", { staticClass: "icon-checked" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "11",
                            height: "9",
                            viewBox: "0 0 11 9",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                              fill: "white",
                              stroke: "white",
                              "stroke-width": "0.3",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._l(_vm.headers, function (header) {
                return _c(
                  "th",
                  {
                    key: header.text,
                    staticClass:
                      "table-header px-2 sm:px-4 py-2 sm:py-4 border-b-1 text-xs sm:text-sm border-gray-200 text-left font-medium",
                    class: {
                      "bg-thead-primary": _vm.currentMode === "ACCEPT",
                      "bg-thead-secondary": _vm.currentMode === "REJECT",
                    },
                  },
                  [_vm._v(" " + _vm._s(header.text) + " ")]
                )
              }),
            ],
            2
          ),
        ]),
        _c(
          "tbody",
          [
            _vm._l(_vm.data.project_activities, function (item, index) {
              return _c(
                "tr",
                { key: index, staticClass: "message-unread table-row" },
                [
                  _c(
                    "td",
                    {
                      staticClass:
                        "checkbox-cell px-1 sm:px-2 py-2 border-b-1 border-gray-200 font-normal",
                    },
                    [
                      _c("label", { staticClass: "custom-checkbox" }, [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: { checked: _vm.isSelected(item) },
                          on: {
                            change: function ($event) {
                              return _vm.handleRowCheckboxChange(item)
                            },
                          },
                        }),
                        _c("span", { staticClass: "icon-checked" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "11",
                                height: "9",
                                viewBox: "0 0 11 9",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                                  fill: "white",
                                  stroke: "white",
                                  "stroke-width": "0.3",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "client-cell px-1 sm:px-2 py-2 sm:py-4 border-b-1 text-left",
                    },
                    [
                      _c("div", { staticClass: "flex text-xs sm:text-sm" }, [
                        _vm._v(" " + _vm._s(_vm.data.client_name) + " "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex font-medium text-xs sm:text-sm" },
                        [
                          _c("span", { staticClass: "hidden sm:inline" }, [
                            _vm._v("Client ID: "),
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.data.client_id ? _vm.data.client_id : "n/a"
                            ) + " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "location-cell px-1 sm:px-2 py-2 sm:py-4 border-b-1 text-left",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex flex-col gap-1 text-xs sm:text-sm",
                        },
                        [
                          item.virtual && item.virtual_meeting_link
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "text-blue-600 hover:underline text-xs truncate max-w-[150px]",
                                  attrs: {
                                    href: item.virtual_meeting_link,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    title: item.virtual_meeting_link,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.virtual_meeting_link) +
                                      " "
                                  ),
                                ]
                              )
                            : item.location
                            ? _c("span", { staticClass: "text-xs" }, [
                                _vm._v(_vm._s(item.location)),
                              ])
                            : _c("span", { staticClass: "text-xs" }, [
                                _vm._v("n/a"),
                              ]),
                          item.virtual && item.fallback_num
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center gap-1 text-gray-600",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c("span", { staticClass: "text-xs" }, [
                                    _vm._v(_vm._s(item.fallback_num)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "datetime-cell px-1 sm:px-2 py-2 sm:py-4 border-b-1 text-left",
                    },
                    [
                      _c("div", { staticClass: "flex text-xs sm:text-sm" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formattedTime(item.start_time, item.timezone)
                            ) +
                            " - " +
                            _vm._s(
                              _vm.formattedTime(item.end_time, item.timezone)
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex text-light-gray text-xs sm:text-sm",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formattedDate(item.start_date)) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "activity-cell px-1 sm:px-2 py-2 sm:py-4 border-b-1 text-left",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-start sm:justify-center items-center text-xs sm:text-sm",
                        },
                        [_vm._v(" " + _vm._s(_vm.typeOfVisit(item)) + " ")]
                      ),
                    ]
                  ),
                ]
              )
            }),
            _vm.data.project_activities.length === 0
              ? _c("tr", [_vm._m(0)])
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", { staticClass: "empty-state", attrs: { colspan: "9" } }, [
      _c("div", { staticClass: "empty-state-text" }, [_vm._v("No resources")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }